import { useAtom } from 'jotai';
import { columnVisibilityModelAtom } from '../Atoms/WorkAssignmentGridAtoms';
import { COLUMN_VISIBILITY_STORAGE_KEY } from '../constants/Constants';

export const useColumnVisibility = () => {
  const [columnVisibility, setColumnVisibility] = useAtom(columnVisibilityModelAtom);

  const handleColumnVisibilityChange = (newModel: Record<string, boolean>) => {
    setColumnVisibility(newModel);
    localStorage.setItem(COLUMN_VISIBILITY_STORAGE_KEY, JSON.stringify(newModel));
  };

  return {
    columnVisibility,
    handleColumnVisibilityChange
  };
};